import { render, staticRenderFns } from "./chooseRoleDiag.vue?vue&type=template&id=a4de8244&scoped=true"
import script from "./chooseRoleDiag.vue?vue&type=script&lang=js"
export * from "./chooseRoleDiag.vue?vue&type=script&lang=js"
import style0 from "./chooseRoleDiag.vue?vue&type=style&index=0&id=a4de8244&prod&lang=stylus&scoped=true"
import style1 from "./chooseRoleDiag.vue?vue&type=style&index=1&id=a4de8244&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4de8244",
  null
  
)

export default component.exports